module.exports = __webpack_public_path__ + "img/a10.ff1edcdc.svg";